<div class="row g-2" [formGroup]="parentForm">
  <div class="col-md col-lg-3">
    <label class="form-label" for="yearSelectGrid">Year</label>
    <select class="form-select form-obrame-select" id="yearInput" formControlName="year">
      @for (y of years; track y) {
        <option [value]="y">{{y}}</option>
      }
    </select>
  </div>
  <div class="col-md col-lg-2">
    <label class="form-label" for="monthSelectGrid">Month</label>
    <select class="form-select form-obrame-select" id="monthSelectGrid" formControlName="month">
      @for (m of months; track m) {
        <option [value]="m">{{m}}</option>
      }
    </select>

  </div>
  <div class="col-md  col-lg-2">
    <label class="form-label" for="daySelectGrid">Day</label>
    <select class="form-select form-obrame-select" id="daySelectGrid" formControlName="day">
      @for (d of days; track d) {
        <option [value]="d">{{d}}</option>
      }
    </select>
  </div>
</div>